import { TopMenuProvider } from "./components/base/topMenuContext";
import Auth from "./configurations/auth/authContext";
import Main from "./Main";
import './configurations/native/BackListener'
import { GlobalLoaderProvider } from "./configurations/useGlobalLoader";
import useQRScanner from "./configurations/useQRScanner";
import ForCameraOpen from "./configurations/native/ForCameraOpen";
import useOnlineStatus from "./configurations/useOnlineStatus";
import OfflineFallback from "./components/OfflineFallback";
import { useEffect } from "react";

function App() {
  const { isQRScanerOn } = useQRScanner();
  const isOnline = useOnlineStatus();

  return (
    <>
      {/* Offline hote hi fallback dikhega, aur internet aate hi
          apne aap hat jayega — app apni jagah wapas aa jayegi */}
      {!isOnline && <OfflineFallback />}

      {isQRScanerOn && <ForCameraOpen />}
      <div className={isQRScanerOn ? "hidden" : "bg-transparent min-h-screen"}>
        <GlobalLoaderProvider>
          <TopMenuProvider>
            <Auth>
              <Main />
            </Auth>
          </TopMenuProvider>
        </GlobalLoaderProvider>
      </div>
           {/* Offline strip — page ke upar neeche fix, sab kuch dikhta rehta hai */}
      {!isOnline && <OfflineFallback />}
    </>
  );
}

export default App;